import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import LinearProgress, {
  LinearProgressProps,
} from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export const ELinearProgressBar = (
  props: LinearProgressProps
): React.ReactElement => (
  <StyledProgress>
    <LinearProgress {...props} />
  </StyledProgress>
);

const StyledProgress = styled.div`
  .MuiLinearProgress-root.MuiLinearProgress-colorPrimary {
    background-color: var(--color-box-border);

    .MuiLinearProgress-bar.MuiLinearProgress-barColorPrimary {
      background-color: var(--color-core-primary);
    }
  }
`;

export const EProgressBar = (
  props: LinearProgressProps & {value: number}
): React.ReactElement => (
  <Box sx={{display: 'flex', alignItems: 'center'}}>
    <Box sx={{width: '100%', mr: 1}}>
      <LinearProgress variant='determinate' {...props} />
    </Box>
    <Box sx={{minWidth: 35}}>
      <Typography color='text.secondary' variant='body2'>{`${Math.round(
        props.value
      )}%`}</Typography>
    </Box>
  </Box>
);
